import axios from "axios";

export function uploadFile(file, url): Promise<any> {
    const data = new FormData()
    data.append('file', file)
    return axios.post(url, data, {
        responseType: 'text'
    })
}